export const originsMatch = (a: string, b: string) => {
  return (
    a === b ||
    a.replace('www.', '') === b ||
    a === b.replace('www.', '')
  )
}
